import { Component, Input, OnInit } from '@angular/core'
import { ActivatedRoute, NavigationStart, Router } from '@angular/router'
import { filter } from 'rxjs/operators'
import { ActionsService } from 'src/app/core/services/actions.service'
import { TimerService } from 'src/app/core/services/timer.service'
import { TransactionGroupsService } from 'src/app/core/services/transaction-groups.service'
import { actions, tabs } from 'src/app/modules/legalization-form/legalization-form.constants'

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  menuItems: Array<any>
  defaultMenuItems: Array<any>
  formMenuItems: Array<any> = []
  currentUrl: string
  currentId: number
  $doc: any = null
  @Input() isCollapsed: boolean

  lastHasSAUValue = null
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private actionsService: ActionsService,
    private transactionGroupsService: TransactionGroupsService,
    private timerService: TimerService
  ) {
    this.setupMenu(false)

    this.transactionGroupsService.hasSAU.subscribe((hasSAU => this.setupMenu(hasSAU)))
  }

  private setupMenu(hasSAU: boolean) {
    if (this.lastHasSAUValue === hasSAU)  {
      return
    } else {
      this.lastHasSAUValue = hasSAU
    }
    this.defaultMenuItems = [
      { heading: 'true', text: 'Κεντρικό Menu' },
      {
        text: 'Παραλαβή<br>Υποθέσεων ΝΠ',
        longText: 'Παραλαβή Υποθέσεων ΝΠ',
        icon: 'landmark',
        link: '/home',
      },
      {
        text: 'Παραληφθείσες<br>Υποθέσεις ΝΠ',
        longText: 'Παραληφθείσες Υποθέσεις ΝΠ',
        icon: 'briefcase',
        link: '/deliverables',
      },
      {
        text: 'Παραλαβή<br>Υποθέσεων ΦΠ',
        longText: 'Παραλαβή Υποθέσεων ΦΠ',
        icon: 'user-tie',
        link: '/inbox-individuals',
      },
      {
        text: 'Παραληφθείσες<br>Υποθέσεις ΦΠ',
        longText: 'Παραληφθείσες Υποθέσεις ΦΠ',
        icon: 'briefcase',
        link: '/deliverables-individuals',
      },
    ]
    const transactionGroupsTabs = this.transactionGroupsService.getTransactionGroupTabs()
    
    if (hasSAU) {
      //remove last two representations tab if we have SAU
      //transactionGroupsTabs.splice(-2, 2)
    }
    this.formMenuItems = []
    this.formMenuItems.push({ heading: 'true', text: 'Ενότητες' })
    this.formMenuItems.push(...tabs)
    this.formMenuItems.push({ heading: 'true', text: 'Συναλλαγές' })
    this.formMenuItems.push(...transactionGroupsTabs)
    this.formMenuItems.push({ heading: 'true', text: 'Ενέργειες' })
    this.formMenuItems.push(...actions)

    this.currentUrl = this.router.url
    this.setMenuItems()
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.currentUrl = event.url
        this.setMenuItems()
      })
  }

  isSidebarCollapsed() {
    return this.isCollapsed
  }

  isSidebarCollapsedText() {
    return false
  }

  isEnabledHover() {
    return false
  }

  calledAction(event: any, func: string) {
    // stop anchor navigation
    event.preventDefault()
    this.actionsService.setAction(func)
  }

  private setMenuItems() {
    if (!this.currentUrl.includes('login')) {
      this.timerService.refreshed()
    }
    if (this.currentUrl.includes('legalization-form')) {
      this.calculateRelativePaths()
      this.menuItems = this.formMenuItems
    } else {
      this.menuItems = this.defaultMenuItems
    }
  }

  private calculateRelativePaths() {
    this.formMenuItems.forEach((i) => {
      if (!!i.tab) {
        i.link = this.currentUrl.substring(0, this.currentUrl.lastIndexOf('/')) + '/' + i.tab
      }
    })
  }
}
